<div class="noSearchInputOrResults">
    <div class="noSearchInputOrResults__item  noSearchInputOrResults__item--no-input" *ngIf="noInput">
        Indtast venligst noget
    </div>
    <div class="noSearchInputOrResults__item  noSearchInputOrResults__item--no-results" *ngIf="noResults && !noInput">
        Ingen resultater fundet
    </div>
</div>
